import React from 'react';
import { View } from 'react-native';
import MyAppText from './MyAppText';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { Image as ReactImage } from 'react-native';


interface PlateProps {
    plate: string;
    isAlert?: boolean;
    highContrast?: boolean;
}

export default function DrawnPlate({ plate, isAlert, highContrast }: PlateProps) {
    const { styles } = useStyles(styleSheet);

    return (<View style={styles.detectionPlate(isAlert, highContrast)}>
        <View style={styles.detectionPlateTopBar}>
            <ReactImage style={styles.plateBrazilFlag} source={require(`../../assets/brazil-flag.png`)} />
        </View>
        <View style={styles.plateContent}>
            <MyAppText style={styles.plateLetters(highContrast)}>{plate}</MyAppText>
        </View>
    </View>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    detectionPlate: (isAlert?: boolean, highContrast?: boolean) => {
        return {
            borderColor: isAlert ? 'red' : 'black',
            backgroundColor: highContrast ? 'white' : undefined,
            borderWidth: 2,
            borderRadius: 8,
            minHeight: 62,
            flex: 1
        };
    },
    detectionPlateTopBar: {
        height: 14,
        width: '100%',
        backgroundColor: '#0F3489',
        alignItems: 'flex-end',
        justifyContent: 'center',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        paddingHorizontal: 15
    },
    plateBrazilFlag: {
        height: 10,
        width: 14,
        overflow: 'hidden',
        borderRadius: 1
    },
    plateContent: {
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1
    },
    plateLetters: (highContrast?: boolean) => {
        return {
            fontWeight: '700',
            fontSize: 24,
            letterSpacing: 8,
            color: highContrast ? 'black' : theme.colors.textColor
        };
    },
}));
